var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicrostrategy = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 3,
  fill: "#D9232E"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.875 17.2482V6.375H8.23918V17.2482H4.875Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4087 17.2482V6.375H13.7729V17.2482H10.4087Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7608 17.2482V6.375L19.125 9.7923V17.2482H15.7608Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrostrategy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microstrategy.6712c182823b7fb19fc407b2eeca8bfc.svg";